
import React from 'react';
import type { ViewType, SidebarItem } from '../types.ts';

interface LeftSidebarProps {
  items: SidebarItem[];
  activeView: ViewType;
  onNavigate: (view: ViewType) => void;
}

const Tooltip: React.FC<{ text: string, children: React.ReactNode }> = ({ text, children }) => {
  return (
    <div className="group relative flex">
      {children}
      <span className="absolute left-14 p-2 scale-0 transition-all rounded bg-slate-800 border border-slate-700 text-xs text-slate-200 group-hover:scale-100 whitespace-nowrap z-50">
        {text}
      </span>
    </div>
  );
};

export const LeftSidebar: React.FC<LeftSidebarProps> = ({ items, activeView, onNavigate }) => {
  return (
    <nav className="w-20 h-full bg-slate-900/70 backdrop-blur-sm border-r border-slate-800 flex flex-col items-center justify-between py-4 px-2 space-y-4">
      <div className="flex flex-col items-center space-y-2">
        <div className="p-2 mb-4">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.6 19.38L12.55 12L16.6 4.62L20.65 12L16.6 19.38ZM7.4 19.38L3.35 12L7.4 4.62L11.45 12L7.4 19.38Z" fill="currentColor" className="text-cyan-400"></path>
            </svg>
        </div>
        {items.map((item) => (
          <Tooltip text={item.label} key={item.id}>
            <button
              onClick={() => {
                if (item.view) onNavigate(item.view);
                if (item.action) item.action();
              }}
              className={`p-3 rounded-lg transition-colors duration-200 ${
                activeView === item.view ? 'bg-cyan-400/20 text-cyan-400' : 'text-slate-500 hover:bg-slate-800 hover:text-slate-300'
              }`}
            >
              {item.icon}
            </button>
          </Tooltip>
        ))}
      </div>
    </nav>
  );
};